import React from 'react';
import { Typography, Container } from '@mui/material';

const RefundPolicy = () => {
  React.useEffect(() => {
    document.title = 'My Store - Refund Policy';
  }, []);

  return (
    <Container maxWidth="md">
      <Typography variant="h4" component="h1" gutterBottom>
        Refund Policy
      </Typography>
      <Typography variant="body1" paragraph>
        Our refund policy is designed to ensure customer satisfaction. Here are the details of our policy:
      </Typography>
      {/* Add more content here */}
    </Container>
  );
};

export default RefundPolicy;